import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NzTableModule } from 'ng-zorro-antd/table';


@Component({
  selector: 'app-table',
  standalone: true,
  imports: [NzTableModule,CommonModule,SharedModule],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  @Input() listOfData: any[] = [];
  @Input() columns: any[] = [];
  @Input() isPagination: boolean = true;
  @Input() nzScrollWidth: string = '';
  @Input() iconType: 'arrow' | 'menu' = 'arrow';
  @Input() showAction: boolean = false;
  @Input() pageIndex: boolean = false;

  // pageSize = 10;
  // pageIndex = 1;
  @Input() totalRecords: number = 0;
  @Input() currentPage: number = 1;
  @Input() pageSize: number = 10;
   @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  onPageChange(page: number) {
    this.pageChange.emit(page);
  }

}
